import React, { useState, useEffect } from 'react';
import Auth from '../services/AuthService'
import AuthenticatedComponent from './AuthenticatedComponent';
import { useNavigate } from 'react-router-dom'
import { connect } from 'react-redux'
import { store } from '../App';
import RateService from '../services/RateService'
import WaitingListService from '../services/WaitingListService';
import { waitingList } from '../reducers/waitingList';

function Settings(props) {
  const navigate = useNavigate();
  
  const [loading, setLoading] = useState(true);
  const [rate, setRate] = useState(props._rate);
  const [saved, setSaved] = useState(false);
  const [chairman, setChairman] = useState(props._chairman);
  const [chairmanPass, setChairmanPass] = useState(props._chairman_password);
  const [treasurer, setTreasurer] = useState(props._treasurer);
  const [treasurerPass, setTreasurerPass] = useState(props._treasurer_password);
  const [vicechairman, setVicechairman] = useState(props._vicechairman);
  const [vicechairmanPass, setVicechairmanPass] = useState(props._vicechairman_password);
  const [secretary, setSecretary] = useState(props._secretary);
  const [secretaryPass, setSecretaryPass] = useState(props._secretary_password);

  const [boardmember1, setBoardmember1] = useState(props._boardmember1);
  const [boardmember1Pass, setBoardmember1Pass] = useState(props._boardmember1_password);
  const [boardmember2, setBoardmember2] = useState(props._boardmember2);
  const [boardmember2Pass, setBoardmember2Pass] = useState(props._boardmember2_password);
  const [boardmember3, setBoardmember3] = useState(props._boardmember3);
  const [boardmember3Pass, setBoardmember3Pass] = useState(props._boardmember3_password);
  const [boardmember4, setBoardmember4] = useState(props._boardmember4);
  const [boardmember4Pass, setBoardmember4Pass] = useState(props._boardmember4_password);

  const [board, setBoard] = useState(null);
  const [boardEditId, setBoardEditId] = useState(null);
  const [boardNew, setBoardNew] = useState(false);
  const [chairmanSaved, setChairmanSaved] = useState(false);
  const [treasurerSaved, setTreasurerSaved] = useState(false);
  const [secretarySaved, setSecretarySaved] = useState(false);
  const [vicechairmanSaved, setVicechairmanSaved] = useState(false);
  const [boardmember1Saved, setBoardmember1Saved] = useState(false);
  const [boardmember2Saved, setBoardmember2Saved] = useState(false);
  const [boardmember3Saved, setBoardmember3Saved] = useState(false);
  const [boardmember4Saved, setBoardmember4Saved] = useState(false);
  const [newBoardMemberName, setNewBoardMemberName] = useState(null);
  const [boardMemberLoading, setBoardMemberLoading] = useState(false);
  const [boardMembersUpdate, setBoardMembersUpdate] = useState(false);

  const requestRate = () => {
    RateService.ratesGet();
  };

  const requestChairman = () => {
    RateService.memberGet('chairman');
  };

  const requestTreasurer = () => {
    RateService.memberGet('treasurer');
  };

  const requestSecretary = () => {
    RateService.memberGet('secretary');
  };

  const requestVicechairman = () => {
    RateService.memberGet('vicechairman');
  };

  const requestBoardmember1 = () => {
    RateService.memberGet('boardmember1');
  };

  const requestBoardmember2 = () => {
    RateService.memberGet('boardmember2');
  };

  const requestBoardmember3 = () => {
    RateService.memberGet('boardmember3');
  };

  const requestBoardmember4 = () => {
    RateService.memberGet('boardmember4');
  };

  const requestBoard = () => {
    RateService.boardGet();
  };

  useEffect(() => {
    requestRate();
  }, []);

  useEffect(() => {
    if (!props._rate) {
      requestRate();
    }

    if (!props._chairman) {
      requestChairman();
    }

    if (!props._treasurer) {
      requestTreasurer();
    }

    if (!props._secretary) {
      requestSecretary();
    }

    if (!props._vicechairman) {
      requestVicechairman();
    }

    if (!props._boardmember1) {
      requestBoardmember1();
    }

    if (!props._boardmember2) {
      requestBoardmember2();
    }

    if (!props._boardmember3) {
      requestBoardmember3();
    }

    if (!props._boardmember4) {
      requestBoardmember4();
    }
    if (!props._board) {
      requestBoard();
    }
  }, [props._rate, props._chairman, props._treasurer, props._secretary, props._vicechairman, props._boardmember1, props._boardmember2, props._boardmember3, props._boardmember4, props._board]);

  const update = (e) => {
    e.preventDefault();
    RateService.ratePut({ rate }).catch(function (err) {
      alert("Der opstod en fejl");
      console.log("Error saving", err);
    });
    setSaved(true);
  };

  const updateChairman = (e) => {
    e.preventDefault();
    RateService.memberPut({
      type: 'chairman',
      value: chairman,
      password: chairmanPass
    }).catch(function (err) {
      alert("Der opstod en fejl");
      console.log("Error saving", err);
    });
    setChairmanSaved(true);
  };

  const updateTreasure = (e) => {
    e.preventDefault();
    RateService.memberPut(
      {
        type: 'treasurer',
        value: treasurer,
        password: treasurerPass
      }
    ).catch(function (err) {
      alert("Der opstod en fejl");
      console.log("Error saving", err);
    });
    setTreasurerSaved(true);
  };

  const updateSecretary = (e) => {
    e.preventDefault();
    RateService.memberPut({
      type: 'secretary',
      value: secretary,
      password: secretaryPass
    }).catch(function (err) {
      alert("Der opstod en fejl");
      console.log("Error saving", err);
    });
    setSecretarySaved(true);
  };

  const updateVicechairman = (e) => {
    e.preventDefault();
    RateService.memberPut({
      type: 'vicechairman',
      value: vicechairman,
      password: vicechairmanPass
    }).catch(function (err) {
      alert("Der opstod en fejl");
      console.log("Error saving", err);
    });
    setVicechairmanSaved(true);
  };

  const updateBoardmember1 = (e) => {
    e.preventDefault();
    RateService.memberPut({
      type: 'boardmember1',
      value: boardmember1,
      password: boardmember1Pass
    }).catch(function (err) {
      alert("Der opstod en fejl");
      console.log("Error saving", err);
    });
    setBoardmember1Saved(true);
  };

  const updateBoardmember2 = (e) => {
    e.preventDefault();
    RateService.memberPut({
      type: 'boardmember2',
      value: boardmember2,
      password: boardmember2Pass
    }).catch(function (err) {
      alert("Der opstod en fejl");
      console.log("Error saving", err);
    });
    setBoardmember2Saved(true);
  };

  const updateBoardmember3 = (e) => {
    e.preventDefault();
    RateService.memberPut({
      type: 'boardmember3',
      value: boardmember3,
      password: boardmember3Pass
    }).catch(function (err) {
      alert("Der opstod en fejl");
      console.log("Error saving", err);
    });
    setBoardmember3Saved(true);
  };

  const updateBoardmember4 = (e) => {
    e.preventDefault();
    RateService.memberPut({
      type: 'boardmember4',
      value: boardmember4,
      password: boardmember4Pass
    }).catch(function (err) {
      alert("Der opstod en fejl");
      console.log("Error saving", err);
    });
    setBoardmember4Saved(true);
  };

  const newBoardMemberClick = (e) => {
    e.preventDefault();

    let currentBoard = board;
    if (currentBoard == null) {
      currentBoard = []
    }

    console.log(currentBoard)
    currentBoard.push({
      value: "",
      new: true
    })

    setBoard(currentBoard);
  };

  const editBoardMemberClick = (entry, e) => {
    e.preventDefault();

    setNewBoardMemberName(entry.value);
    setBoardEditId(entry.id);
  };

  const updateBoardMemberClick = (entry, e) => {
    e.preventDefault();

    entry.value = newBoardMemberName

    RateService.updateBoardMember({
      boardmember: entry
    }).catch(function (err) {
      alert("Der opstod en fejl");
      console.log("Error saving", err);
    });

    setNewBoardMemberName(null);
    setBoardMemberLoading(true);
    setBoardEditId(null);
  };

  const createBoardMemberClick = (entry, e) => {
    e.preventDefault();

    RateService.newBoardMember({
      name: newBoardMemberName
    }).catch(function (err) {
      alert("Der opstod en fejl");
      console.log("Error saving", err);
    });

    setNewBoardMemberName(null);
    setBoardMemberLoading(true);
    setBoardEditId(null);
  };

  const rmBoardMemberClick = (entry, e) => {
    e.preventDefault();

    RateService.deleteBoardMember({
      id: entry.id,
    }).catch(function (err) {
      alert("Der opstod en fejl");
      console.log("Error deleting", err);
    });
  };

  const scheduleWaitinglistCleanup = () => {
    WaitingListService.scheduleCleanup().then((response) => {
      window.alert('Rengøringsjobbet er nu sat til at køre regelmæssigt og det sletter automatisk venteliste ansøgninger som hverken er godkendt eller betalt indenfor få dage. (Ansøgninger på den interne liste vil dog IKKE blive slette automatisk.)');
    });
  };

  useEffect(() => {
    if (loading && props._boardmember4_password !== null) {
      setLoading(false);
      setRate(props._rate);
      setChairman(props._chairman);
      setChairmanPass(props._chairman_password);
      setTreasurer(props._treasurer);
      setTreasurerPass(props._treasurer_password);
      setBoard(props._board);
      setSecretary(props._secretary);
      setSecretaryPass(props._secretary_password);
      setVicechairman(props._vicechairman);
      setVicechairmanPass(props._vicechairman_password);
      setBoardmember1(props._boardmember1);
      setBoardmember1Pass(props._boardmember1_password);
      setBoardmember2(props._boardmember2);
      setBoardmember2Pass(props._boardmember2_password);
      setBoardmember3(props._boardmember3);
      setBoardmember3Pass(props._boardmember3_password);
      setBoardmember4(props._boardmember4);
      setBoardmember4Pass(props._boardmember4_password);
    }
  }, [loading, props]);

  var boardMembers = [];

  if (board) {
    board.forEach(function (entry) {
      if ((boardEditId === entry.id) || (entry.new)) {
        var saveClick = boardEditId ? updateBoardMemberClick : createBoardMemberClick;
        boardMembers.push(<tr key={entry.id || 'new'}>
          <td className="col-md-4 boardMemberName">Bestyrelsesmedlem</td>
          <td className="col-md-6" style={{ paddingLeft: '0' }}><input className="form-control" name="type" value={newBoardMemberName} onChange={(event) => setNewBoardMemberName(event.target.value)} type="text" /></td>
          <td className="col-md-4" style={{ whiteSpace: 'nowrap' }}>
            <button className="btn btn-primary pull-right" onClick={(e) => saveClick(entry, e)}>Gem</button>
          </td>
        </tr>);
      } else {
        boardMembers.push(<tr key={entry.id}>
          <td className="col-md-4 boardMemberName">Bestyrelsesmedlem</td>
          <td className="col-md-6" style={{ paddingLeft: '0' }}>{entry.value}</td>
          <td className="col-md-4" style={{ textAlign: "right", whiteSpace: 'nowrap' }}>
            <button className="btn btn-primary" onClick={(e) => rmBoardMemberClick(entry, e)}>Slet</button>
            &nbsp;
            <button className="btn btn-primary" onClick={(e) => editBoardMemberClick(entry, e)}>Opdater</button>
          </td>
        </tr>);
      }
    });
  }

  boardMembers.push(<tr key="add-new">
    <td colSpan="9">
      <button className="btn btn-primary" onClick={newBoardMemberClick}>Tilføj</button>
    </td>
  </tr>)

    return (
      <div className="container standardBackground">
        <div className="row">
          <div className=" col-md">
            <h2 className="textAlignCenter">Bestyrelsesmedlemmer</h2>
            <div className="row">
              <form className="col-md-4">
                {saved && <label className="alert alert-success">Andelskronen er nu opdateret</label>}
                <div className="form-group">
                  <label>Andelskrone (kr.)</label>
                  <input type="text" value={rate} onChange={(event) => setRate(event.target.value)} className=" form-control" />
                </div>
                <div className="form-buttons">
                  <button type="submit" className="btn btn-primary" onClick={update}>Opdater</button>
                </div>
              </form>
              <form className="col-md-4">
                {chairmanSaved && <label className="alert alert-success">Formand er nu opdateret</label>}
                <div className="form-group">
                  <label>Formand</label>
                  <input type="text" value={chairman} onChange={(event) => setChairman(event.target.value)} className=" form-control" />
                  {/* <input type="password" value={chairmanPass} onChange={(event) => setChairmanPass(event.target.value)} className="form-control" /> */}
                </div>
                <div className="form-buttons">
                  <button type="submit" className="btn btn-primary" onClick={updateChairman}>Opdater</button>
                </div>
              </form>
              <form className="col-md-4">
                {vicechairmanSaved && <label className="alert alert-success">Næstformand er nu opdateret</label>}
                <div className="form-group">
                  <label>Næstformand</label>
                  <input type="text" value={vicechairman} onChange={(event) => setVicechairman(event.target.value)} className=" form-control" />
                  {/* <input type="password" value={vicechairmanPass} onChange={(event) => setVicechairmanPass(event.target.value)} className="form-control" /> */}
                </div>
                <div className="form-buttons">
                  <button type="submit" className="btn btn-primary" onClick={updateVicechairman}>Opdater</button>
                </div>
              </form>
            </div>
            <div className="row">
              <form className="col-md-4">
                {treasurerSaved && <label className="alert alert-success">Kassere er nu opdateret</label>}
                <div className="form-group">
                  <label>Kassere</label>
                  <input type="text" value={treasurer} onChange={(event) => setTreasurer(event.target.value)} className=" form-control" />
                  {/* <input type="password" value={treasurerPass} onChange={(event) => setTreasurerPass(event.target.value)} className=" form-control" /> */}
                </div>
                <div className="form-buttons">
                  <button type="submit" className="btn btn-primary" onClick={updateTreasure}>Opdater</button>
                </div>
              </form>
              <form className="col-md-4">
                {secretarySaved && <label className="alert alert-success">Sekretær er nu opdateret</label>}
                <div className="form-group">
                  <label>Sekretær</label>
                  <input type="text" value={secretary} onChange={(event) => setSecretary(event.target.value)} className="form-control" />
                  {/* <input type="password" value={secretaryPass} onChange={(event) => setSecretaryPass(event.target.value)} className=" form-control" /> */}
                </div>
                <div className="form-buttons">
                  <button type="submit" className="btn btn-primary" onClick={updateSecretary}>Opdater</button>
                </div>
              </form>
              <form className="col-md-4">
                {boardmember1Saved && <label className="alert alert-success">Bestyrelsesmedlem 1 er nu opdateret</label>}
                <div className="form-group">
                  <label>Bestyrelsesmedlem 1</label>
                  <input type="text" value={boardmember1} onChange={(event) => setBoardmember1(event.target.value)} className="form-control" />
                  {/* <input type="password" value={boardmember1Pass} onChange={(event) => setBoardmember1Pass(event.target.value)} className=" form-control" /> */}
                </div>
                <div className="form-buttons">
                  <button type="submit" className="btn btn-primary" onClick={updateBoardmember1}>Opdater</button>
                </div>
              </form>
            </div>
            <div className="row">
              <form className="col-md-4">
                {boardmember2Saved && <label className="alert alert-success">Bestyrelsesmedlem 2 er nu opdateret</label>}
                <div className="form-group">
                  <label>Bestyrelsesmedlem 2</label>
                  <input type="text" value={boardmember2} onChange={(event) => setBoardmember2(event.target.value)} className="form-control" />
                  {/* <input type="password" value={boardmember2Pass} onChange={(event) => setBoardmember2Pass(event.target.value)} className=" form-control" /> */}
                </div>
                <div className="form-buttons">
                  <button type="submit" className="btn btn-primary" onClick={updateBoardmember2}>Opdater</button>
                </div>
              </form>
              <form className="col-md-4">
                {boardmember3Saved && <label className="alert alert-success">Bestyrelsesmedlem 3 er nu opdateret</label>}
                <div className="form-group">
                  <label>Bestyrelsesmedlem 3</label>
                  <input type="text" value={boardmember3} onChange={(event) => setBoardmember3(event.target.value)} className="form-control" />
                  {/* <input type="password" value={boardmember3Pass} onChange={(event) => setBoardmember3Pass(event.target.value)} className=" form-control" /> */}
                </div>
                <div className="form-buttons">
                  <button type="submit" className="btn btn-primary" onClick={updateBoardmember3}>Opdater</button>
                </div>
              </form>
              <form className="col-md-4">
                {boardmember4Saved && <label className="alert alert-success">Bestyrelsesmedlem 4 er nu opdateret</label>}
                <div className="form-group">
                  <label>Bestyrelsesmedlem 4</label>
                  <input type="text" value={boardmember4} onChange={(event) => setBoardmember4(event.target.value)} className="form-control" />
                  {/* <input type="password" value={boardmember4Pass} onChange={(event) => setBoardmember4Pass(event.target.value)} className=" form-control" /> */}
                </div>
                <div className="form-buttons">
                  <button type="submit" className="btn btn-primary" onClick={updateBoardmember4}>Opdater</button>
                </div>
              </form>
            </div>
            {boardMembersUpdate &&
              <div>Opdatering vellykket</div>}
            {!boardMembersUpdate &&
              <div>
                <table className="table boardMemberList">
                  <tbody>{boardMembers}</tbody>
                </table>
              </div>}
          </div>
        </div>
        <div className='row'>
          <div className="col-md">
            <h2 className="textAlignCenter">Avancerede funktioner</h2>
            <p>Brug nedenstående avancerede funktioner med forsigtighed. Altså, tryk kun hvis du ved hvad du gør.</p>

              <h3>Rengøringsjob</h3>
              <div>Skemalæg rengøringsjob. Rengøringsjobbet kører regelmæssigt og sletter alle ikke godkendte ventelisteansøgninger, som ikke er blevet betalt. Ansøgninger til den interne venteliste slettes dog ikke ligesom ansøgninger der er modtaget de seneste dage heller ikke fjernes. Når først jobbet er skeduleret en enkelt gang vil det ikke være nødvendigt at klikke her igen.</div>
              <div><button className="btn btn-primary pull-right" onClick={scheduleWaitinglistCleanup}>Skemalæg nu</button></div>
          </div>
        </div>
      </div>
    );
}


function mapStateToProps(state) {
  const { _rate, _board, _boardLoading, _chairman, _chairman_password, _treasurer, _treasurer_password, _secretary, _secretary_password, _vicechairman, _vicechairman_password, _boardmember1, _boardmember1_password, _boardmember2, _boardmember2_password, _boardmember3, _boardmember3_password, _boardmember4, _boardmember4_password } = state.rate;
  return { _rate, _board, _boardLoading, _chairman, _chairman_password, _treasurer, _treasurer_password, _secretary, _secretary_password, _vicechairman, _vicechairman_password, _boardmember1, _boardmember1_password, _boardmember2, _boardmember2_password, _boardmember3, _boardmember3_password, _boardmember4, _boardmember4_password };
}



export default AuthenticatedComponent(connect(mapStateToProps)(Settings))